import {
  EmailVerfiedPayload,
  ForgotPasswordPayload,
  LoginActionPayload,
  RefreshTokenPayload,
  RemoveAwardPayload,
  ResetPasswordPayload,
  SignupActionPayload,
  UpdateCompanyPayload
} from "@/store/modules/auth/interfaces";
import axios, { AxiosResponse } from "axios";
import {
  FORGOT_PASSWORD,
  GET_USER,
  GOOGLE_AUTH,
  LINKEDIN_AUTH,
  LOGIN,
  LOGOUT_USER,
  REFRESH_TOKEN,
  REMOVE_HIGHLIGHT_AWARDS,
  RESET_PASSWORD,
  SIGNUP,
  UPDATE_COMPANY_DETAILS,
  UPDATE_PROFILE,
  UPDATE_USER_DETAILS,
  USER_PROFILE,
  VERIFY_EMAIL
} from "@/store/urls/auth";
import { Candidates } from "@/interfaces/data_objects/candidates";
import { UPLOAD_HIGHLIGHT_AWARDS } from "@/store/urls/auth";

export const login_user = async (
  payload: LoginActionPayload
): Promise<AxiosResponse> => {
  return await axios.post(LOGIN, payload);
};

export const signup_user = async (
  payload: SignupActionPayload
): Promise<AxiosResponse> => {
  return await axios.post(SIGNUP, payload).then((response) => response.data);
};

export const verify_email = async (
  payload: EmailVerfiedPayload
): Promise<AxiosResponse> => {
  return await axios.post(`${VERIFY_EMAIL}${payload.token}`, {
    email: payload.email
  });
};

export const get_user = async (id?: number): Promise<AxiosResponse> => {
  return await axios.get(`${GET_USER}${id ? id : ""}`);
};

export const google_auth = async (): Promise<void> => {
  window.location.href = GOOGLE_AUTH;
};

export const linkedin_auth = async (): Promise<void> => {
  window.location.href = LINKEDIN_AUTH;
};

export const get_user_profile = async (id?: number): Promise<AxiosResponse> => {
  return await axios.get(`${USER_PROFILE}${id ? id : ""}`);
};

export const update_user_details = async (
  payload: FormData
): Promise<AxiosResponse> => {
  return axios.patch(UPDATE_USER_DETAILS, payload);
};

export const reset_password = async (
  payload: ResetPasswordPayload
): Promise<AxiosResponse> => {
  return axios.post(RESET_PASSWORD, payload);
};

export const forgot_password = async (
  payload: ForgotPasswordPayload
): Promise<AxiosResponse> => {
  return axios.post(FORGOT_PASSWORD, payload);
};

export const update_user_profile = async (
  payload: Candidates.CandidateDetails
): Promise<AxiosResponse> => await axios.patch(UPDATE_PROFILE, payload);

export const update_user_company = async (
  payload: UpdateCompanyPayload
): Promise<AxiosResponse> => await axios.patch(UPDATE_COMPANY_DETAILS, payload);

export const upload_highlight_awards = async (
  payload: FormData
): Promise<AxiosResponse> => {
  return await axios.post(UPLOAD_HIGHLIGHT_AWARDS, payload);
};

export const remove_highlight_awards = async (
  payload: RemoveAwardPayload
): Promise<AxiosResponse> => {
  return await axios.delete(
    `${REMOVE_HIGHLIGHT_AWARDS}?reward_id=${payload.id}&uid=${payload.uid}`
  );
};

export const refresh_token = async (
  payload: RefreshTokenPayload
): Promise<AxiosResponse> => {
  return await axios.post(REFRESH_TOKEN, payload);
};

export const logout_user = async (user_id: number): Promise<AxiosResponse> => {
  return await axios.get(`${LOGOUT_USER}${user_id}`);
};
